import React, {Component} from "react";
import {v4 as uuidv4} from 'uuid';

import Layout from "../layout";
import SmsForm from "../sms-form";
import './payment-page.css'
import {
    fetchSendSms,
    fetchCheckSms,
    fetchLoanInfo,
    fetchCreatePayment,
    fetchSendSmsPage,
    STEP_SEND_SMS,
    STEP_CHECK_SMS,
    STEP_LOAN_INFO,
    STEP_PAYMENT_PAGE,
    fetchPaymentByTokenPage,
    STEP_PAYMENT_BY_TOKEN, fetchLoanInfoPage
} from '../../actions'
import {connect} from "react-redux";
import withLoanService from "../hoc/with-loan-service";
import {compose} from "../../utils";
import LoanInfo from "../loan-info";
import withRouter from "../hoc/with-router";
import PaymentMethod from "../payment-method";
import {BsArrowLeft} from "react-icons/bs";
import {withTranslation} from "react-i18next";


class PaymentPage extends Component {
    sendSms = (iin) => {
        const {fetchSendSms} = this.props
        fetchSendSms(iin)
    }
    checkSms = (smsCode) => {
        const {fetchCheckSms, sms: {data: {verificationId}}} = this.props
        fetchCheckSms(verificationId, smsCode)

    }
    createPayment = () => {
        //const baseUrl = "https://pay.airbapay.kz/"
        const baseUrl="https://spay.airbapay.kz/"
        const {fetchCreatePayment, app: {data: {accessToken, fromSite, backUrl}}} = this.props
        const {loan: {data}} = this.props
        const {customer: {customer_id}, loans_info: {current_plan_payment: {paymentKey}}} = data
        let successUrl = baseUrl+"success"
        let failureUrl = baseUrl+"error"
        if (!fromSite){
            successUrl = successUrl+"?backUrl="+backUrl
            failureUrl = failureUrl+"?backUrl="+backUrl
        }
        const paymentData  = {
            tdid:customer_id,
            uuid:uuidv4(),
            pkey:paymentKey,
            successUrl:successUrl,
            failureUrl:failureUrl,
        }
        fetchCreatePayment(accessToken, paymentData)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {app: {data: {accessToken, step }}, loan, fetchLoanInfo} = this.props
        const {data, loading, error} = loan
        if (step===STEP_LOAN_INFO && accessToken !== '' && data === null && !loading && error == null) {
            fetchLoanInfo(accessToken)
        }
    }

    getLoanInfo = () => {
        const {app: {data: {accessToken}}, fetchLoanInfo, fetchLoanInfoPage} = this.props
        fetchLoanInfoPage()
        fetchLoanInfo(accessToken)
    }
    onStartPage = () => {
        const {app: {data: {fromSite}},fetchSendSmsPage, fetchPaymentByTokenPage} = this.props
        console.log(this.props)
        if(fromSite) {
            fetchSendSmsPage()
        } else {
            const {params:{data}} = this.props
            fetchPaymentByTokenPage(JSON.parse(atob(data)))
        }
    }

    backToShopLink = () =>{
        const {app: {data: {fromSite,backUrl}},t} = this.props
        if (fromSite){
            return ''
        }
        return (
            <div  className="mt-3">
                <a href={backUrl} className="apay-backurl-shop"><BsArrowLeft/> {t('backToShop')}</a>
            </div>
        )
    }
    render() {
        const {app: {data: {accessToken, step}}, params:{data}, fetchPaymentByTokenPage} = this.props
        console.log(data)
        if (data!==null && data!==undefined && accessToken===''){
            fetchPaymentByTokenPage(JSON.parse(atob(data)))
            return <div>loading</div>
        }

        switch (step) {
            case STEP_SEND_SMS:
            case STEP_CHECK_SMS:
                const {sms} = this.props
                return (
                    <Layout>
                        <SmsForm sendSms={this.sendSms}
                                     checkSms={this.checkSms}
                                     isCheckSms={step === STEP_CHECK_SMS}
                                     smsData={sms}
                                     backToShopLink={this.backToShopLink}/>
                    </Layout>
                )
            case STEP_LOAN_INFO:
                const {loan, payment} = this.props
                return (
                    <Layout>
                        <LoanInfo
                            loan={loan}
                            payment={payment}
                            createPayment={this.createPayment}
                            onStartPage={this.onStartPage}
                            backToShopLink={this.backToShopLink()}/>
                    </Layout>
                )
            case STEP_PAYMENT_PAGE:
                const {payment: {data}} = this.props
                if (data !== null) {
                    const {paymentUrl} = data
                    window.location = paymentUrl
                }
                return <Layout></Layout>
            case STEP_PAYMENT_BY_TOKEN:
                return (
                    <Layout>
                        <PaymentMethod
                            onContinue={()=>{ this.getLoanInfo()}}
                            backToShopLink={this.backToShopLink()}/>
                    </Layout>
                )
            default:
                return <Layout></Layout>
        }
    }
}

const mapStateToProps = ({app, sms, loan, payment}) => {
    return {
        app,
        sms,
        loan,
        payment,
    }
}
const mapDispatchToProps = (dispatch, {loanService}) => {
    return {
        fetchPaymentByTokenPage: fetchPaymentByTokenPage(dispatch),
        fetchSendSmsPage: fetchSendSmsPage(dispatch),
        fetchSendSms: fetchSendSms(loanService, dispatch),
        fetchCheckSms: fetchCheckSms(loanService, dispatch),
        fetchLoanInfo: fetchLoanInfo(loanService, dispatch),
        fetchCreatePayment: fetchCreatePayment(loanService, dispatch),
        fetchLoanInfoPage: fetchLoanInfoPage(dispatch),
    };
}
export default compose(
    withTranslation(),
    withRouter(),
    withLoanService(),
    connect(mapStateToProps, mapDispatchToProps)
)(PaymentPage);